<template>
  <div
      v-loading="loadingHead || loadingSalesOrder || loadingBusinessApplication || loadingStorageInspectControl || loadingFileReleaseAgendaControl|| loadingImprovedSurveyApproveControl"
      style="height: 86vh; overflow-y: auto">
    <approval-head-form
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        @sucess-save="submit"
        @loading-status="loadingStatusHead"/>
    <sales-order-preview
        v-if="billType === '1'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        @loading-status="loadingStatusSalesOrder"/>
    <business-application-preview
        v-if="billType === '3'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingStatusBusinessApplication"/>
    <business-application-price-apply-preview
        v-if="billType === '20'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingStatusBusinessApplicationPriceApply"/>
    <inspection-report-preview
        v-if="billType === '23'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingStorageInspect"/>
    <process-exception-preview
        v-if="billType === '24'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingProcessException"/>
    <file-release-agenda-preview
        v-if="billType === '25'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingFileReleaseAgenda"/>
    <maintain-preview
        v-if="billType === '26'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingMaintain"/>
    <reconcile-order-preview
        v-if="billType === '27'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingReconcileOrder"/>
    <appointment-approve-preview
        v-if="billType === '15'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingAppointmentApprove"/>
    <improved-survey-preview
        v-if="billType === '28'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingImprovedSurveyApprove"/>
    <replacement-approve-preview
        v-if="billType === '13'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingReplacementApprove"/>
    <inspection-shipment-preview
        v-if="billType === '29'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingShipmentApprove"/>
    <pui-approve-preview
        v-if="billType === '31'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingPuiApprove"/>
    <cs-special-approve-preview
        v-if="billType === '32'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingCsSpecialApprove"/>
    <yi-xin-application-preview
        v-if="billType === '33'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingYiXinApplicationApprove"/>
    <return-order-preview
        v-if="billType === '35'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingReturnOrderApprove"/>
    <disassemble-order-preview
        v-if="billType === '36'"
        :bill-id="billId"
        :bill-type="billType"
        :sequ-id="sequId"
        :params="params"
        @loading-status="loadingDisassembleOrderApprove"/>
  </div>
</template>
<script>
  import ApprovalHeadForm from "./ApprovalHeadForm.vue";
  import SalesOrderPreview from "./SalesOrderPreview.vue";
  import BusinessApplicationPreview from "./BusinessApplicationPreview.vue";
  import BusinessApplicationPriceApplyPreview from "./BusinessApplicationPriceApplyPreview";
  import InspectionReportPreview from "@/views/workFlow/InspectionReportPreview";
  import ProcessExceptionPreview from "@/views/workFlow/ProcessExceptionPreview";
  import FileReleaseAgendaPreview from "@/views/workFlow/FileReleaseAgendaPreview";
  import ReconcileOrderPreview from "@/views/workFlow/ReconcileOrderPreview";
  import AppointmentApprovePreview from "@/views/workFlow/AppointmentApprovePreview";
  import ImprovedSurveyPreview from "@/views/workFlow/ImprovedSurveyPreview";
  import ReplacementApprovePreview from "@/views/workFlow/ReplacementApprovePreview";
  import InspectionShipmentPreview from "@/views/workFlow/InspectionShipmentPreview";
  import PuiApprovePreview from "@/views/workFlow/PuiApprovePreview";
  import CsSpecialApprovePreview from "@/views/workFlow/CsSpecialApprovePreview";
  import YiXinApplicationPreview from "@/views/workFlow/YiXinApplicationPreview";
  import ReturnOrderPreview from "@/views/workFlow/ReturnOrderPreview";
  import DisassembleOrderPreview from "@/views/workFlow/DisassembleOrderPreview";
  import MaintainPreview from "@/views/workFlow/MaintainPreview";

  export default {
    name: "",
    components: {
      MaintainPreview,
      DisassembleOrderPreview,
      ReturnOrderPreview,
      YiXinApplicationPreview,
      CsSpecialApprovePreview,
      PuiApprovePreview,
      InspectionShipmentPreview,
      ReplacementApprovePreview,
      ImprovedSurveyPreview,
      AppointmentApprovePreview,
      ProcessExceptionPreview,
      InspectionReportPreview,
      BusinessApplicationPriceApplyPreview,
      ApprovalHeadForm,
      SalesOrderPreview,
      BusinessApplicationPreview,
      FileReleaseAgendaPreview,
      ReconcileOrderPreview,
    },
    data() {
      return {
        loadingHead: false,
        loadingSalesOrder: false,
        loadingBusinessApplication: false,
        loadingBusinessApplicationPriceApply: false,
        loadingStorageInspectControl: false,
        loadingProcessExceptionControl: false,
        loadingFileReleaseAgendaControl: false,
        loadingMaintainControl: false,
        loadingReconcileOrderControl: false,
        loadingAppointmentApproveControl: false,
        loadingImprovedSurveyApproveControl: false,
        loadingReplacementApproveControl: false,
        loadingShipmentApproveControl: false,
        loadingPuiApproveControl: false,
        loadingCsSpecialApproveControl: false,
        loadingYiXinApplication: false,
        loadingReturnOrder: false,
        loadingDisassembleOrder: false,
        billId: null,
        billType: null,
        sequId: null,
        params: {},
      };
    },
    created() {
      this.billType = this.$route.query.billType + "";
      this.billId = this.$route.query.billId + "";
      this.sequId = this.$route.query.sequId + "";
    },
    mounted() {
    },
    methods: {
      submit(row) {
        this.params = row;
      },
      loadingStatusHead(obj) {
        this.loadingHead = obj.loading;
      },
      loadingStatusSalesOrder(obj) {
        this.loadingSalesOrder = obj.loading;
      },
      loadingStatusBusinessApplication(obj) {
        this.loadingBusinessApplication = obj.loading;
      },
      loadingStatusBusinessApplicationPriceApply(obj) {
        this.loadingBusinessApplicationPriceApply = obj.loading;
      },
      loadingStorageInspect(obj) {
        this.loadingStorageInspectControl = obj.loading;
      },
      loadingProcessException(obj) {
        this.loadingProcessExceptionControl = obj.loading;
      },
      loadingFileReleaseAgenda(obj) {
        this.loadingFileReleaseAgendaControl = obj.loading;
      },
      loadingMaintain(obj) {
        this.loadingMaintainControl = obj.loading;
      },
      loadingReconcileOrder(obj) {
        this.loadingReconcileOrderControl = obj.loading;
      },
      loadingAppointmentApprove(obj) {
        this.loadingAppointmentApproveControl = obj.loading;
      },
      loadingImprovedSurveyApprove(obj) {
        this.loadingImprovedSurveyApproveControl = obj.loading;
      },
      loadingReplacementApprove(obj) {
        this.loadingReplacementApproveControl = obj.loading;
      },
      loadingShipmentApprove(obj) {
        this.loadingShipmentApproveControl = obj.loading;
      },
      loadingPuiApprove(obj) {
        this.loadingPuiApproveControl = obj.loading;
      },
      loadingCsSpecialApprove(obj) {
        this.loadingCsSpecialApproveControl = obj.loading;
      },
      loadingYiXinApplicationApprove(obj) {
        this.loadingYiXinApplication = obj.loading;
      },
      loadingReturnOrderApprove(obj) {
        this.loadingReturnOrder = obj.loading;
      },
      loadingDisassembleOrderApprove(obj) {
        this.loadingDisassembleOrder = obj.loading;
      },
    },
  };
</script>
<style lang="scss" scoped></style>
